export enum DeviceMode {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
}
